(function (angular) {
    'use strict';

    angular.module('branchReports')
        .factory('channelsService', [
            '$http', "portalConfig", "$q", function ($http, portalConfig, $q) {
                var urlBase = portalConfig.urlBase;

                var fac = {
                    getQueriedData: getQueriedData,
                    getQueriedDataAgregated: getQueriedDataAgregated,
                    getQueriedMetricsAgregated: getQueriedMetricsAgregated,
                    getQueryDataCountrySplit: getQueryDataCountrySplit
                };
                return fac;

                function getQueriedData(id, data, timezone) {
                    var url = urlBase + "/apispaces/" + id + "/analytics/messages?from=" + data.from.value.toISOString() + "&to=" + data.to.value.toISOString() + "&by=" + data.by;
                    if (timezone) {
                        url = url + '&timezone=' + timezone;
                    }
                    if (data.system) {
                        url = url + '&system=' + data.system;
                    }

                    return $http.get(url)
                        .then(getQueriedDataComplete)
                        .catch(getQueriedDataFailed);

                }
                function getQueriedDataAgregated(id, data, timezone) {
                    var url = urlBase + "/apispaces/" + id + "/analytics/messages?from=" + data.from.value.toISOString() + "&to=" + data.to.value.toISOString() + "&by=alltime";
                    if (timezone) {
                        url = url + '&timezone=' + timezone;
                    }
                    if (data.system) {
                        url = url + '&system=' + data.system;
                    }

                    return $http.get(url)
                        .then(getQueriedDataComplete)
                        .catch(getQueriedDataFailed);

                }

                function getQueriedMetricsAgregated(id, data, timezone) {
                    var url = urlBase + "/apispaces/" + id + "/analytics/messages/metrics?from=" + data.from.value.toISOString() + "&to=" + data.to.value.toISOString() + "&by=alltime";
                    if (timezone) {
                        url = url + '&timezone=' + timezone;
                    }
                    if (data.system) {
                        url = url + '&system=' + data.system;
                    }

                    return $http.get(url)
                        .then(getQueriedDataComplete)
                        .catch(getQueriedDataFailed);

                }


                function getQueryDataCountrySplit(id, data, timezone) {
                    var url = urlBase + "/apispaces/" + id + "/analytics/messages?from=" + data.from.value.toISOString() + "&to=" + data.to.value.toISOString() + "&by=" + data.by + "&by=recipientCountryCode";
                    if (timezone) {
                        url = url + '&timezone=' + timezone;
                    }
                    if (data.system) {
                        url = url + '&system=' + data.system;
                    }

                    return $http.get(url)
                        .then(getQueriedDataComplete)
                        .catch(getQueriedDataFailed);
                }

                function getQueriedDataComplete(response) {
                    return response.data;
                }

                function getQueriedDataFailed(error) {
                    console.error(JSON.stringify(error));
                    return $q.reject(error);
                }

            }
        ]);
})(window.angular);